import React from 'react';
import Navbar from './Navbar';
import Sidebar from './Sidebar';
import LabContentOld from './LabContentOld';
import Footer from './Footer';
import './css/Lab.css';

const LabOld = ({ isCollapsed, toggleSidebar }) => {
    return (
        <div className='lab-container'>
            <Navbar />
            <div className='lab-side-content'>
                <Sidebar active_n={2} isCollapsed={isCollapsed} toggleSidebar={toggleSidebar} />
                <LabContentOld />
            </div>
            <Footer />
        </div>
    );
};

export default LabOld;
